import { UrlCollection } from '../url-collection'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { HttpClient, HttpResponse } from '@angular/common/http'
import { HttpResult } from '../models/http/http-result'
import { FileUploadResult } from '../models/http/file-upload-result'

@Injectable({
  providedIn: 'root'
})
export class FileUploadDownloadService {
  constructor(private http: HttpClient) {}

  public getDownloadUrl(fileId: number): string {
    return UrlCollection.Files.generateDownloadUrl(fileId)
  }

  public getUploadUrl(ownerType: string, ownerId: number): string {
    return !!ownerId
      ? UrlCollection.Files.generateFileAttachmentUploadUrl(ownerType, ownerId)
      : UrlCollection.Files.generateUploadUrl()
  }

  public getLicenseUploadUrl(): string {
    return UrlCollection.Admin.UPLOAD_LICENSE()
  }

  public getUpdateFileUrl(): string {
    return UrlCollection.Files.UPDATE()
  }

  public readUploadResult(response: HttpResponse<FileUploadResult>): HttpResult<FileUploadResult> {
    if (response.ok) {
      return {
        success: true,
        result: response.body
      }
    }
    return {
      success: false,
      errMsg: response.statusText
    }
  }

  // don't we have an image service?
  public getImage(imageFileId): Observable<Blob> {
    return this.http.get(this.getDownloadUrl(imageFileId), { responseType: 'blob' })
  }

  public getTempFile(id: string): Observable<HttpResponse<Blob>> {
    return this.http.get(UrlCollection.Files.generateDownloadTempFileUrl(id), {
      observe: 'response',
      responseType: 'blob'
    })
  }

  createImageFromBlob(image: Blob) {
    const reader = new FileReader()
    reader.addEventListener(
      'load',
      () => {
        const imageToShow = reader.result
        console.log('image to show: ', imageToShow)
      },
      false
    )

    if (image) {
      reader.readAsDataURL(image)
    }
  }
}
